import * as API from "middleware/api";

export const listVeps = (data) => API.executeWithAccessToken("/veps.list", data);

export const listTaxpayers = (data) => API.executeWithAccessToken("/vep.taxpayers.list", data);

export const addTaxpayer = (params) => API.executeWithAccessToken("/vep.taxpayers.add", params);

export const deleteVEPTaxpayer = (params) => API.executeWithAccessToken("/vep.taxpayers.delete", params);

export const deleteVEP = (params) => API.executeWithAccessToken("/vep.delete", params);

export const accessAfipPortal = () => API.executeWithAccessToken("/vep.afip.access");

export const downloadVepDetail = (vep, format, vepHistoric, vepType) =>
    API.executeWithAccessToken("/vep.detail.download", { vep, format, vepHistoric, vepType });

export const processVepPayment = (params) => API.executeWithAccessToken("/veps.process.payment", params);

export const getPaymentScheduleRequest = (params) => API.executeWithAccessToken("/get.payment.schedule", params);

export const getDebtByCuitRequest = (cuit) => API.executeWithAccessToken("/afip.services.payment.pre", cuit);

export const addEntityRequest = (cuit) => API.executeWithAccessToken("/add.entity", cuit);

export const processServicesPayment = (params) => API.executeWithAccessToken("/afip.services.process.payment", params);

export const addServicesPaymentPre = (params) => API.executeWithAccessToken("/add.service.link.pre", params);

export const verifyServiceSchedule = (params) =>
    API.executeWithAccessToken("/service.payment.link.verify.scheduled", params);

export const adheredServicesList = () => API.executeWithAccessToken(`/link.service.list`);

export const deleteAdheredService = (linkCode) => API.executeWithAccessToken(`/adhered.service.delete`, { linkCode });

export const editAdheredService = (linkCode, alias) =>
    API.executeWithAccessToken(`/adhered.service.edit`, { linkCode, alias });

export const newServicesPaymentPre = (params) => API.executeWithAccessToken("/service.payment.link.pre", params);

export const linkService = (params) => {
    return API.executeWithAccessToken(`/link.service`, params);
}

export const generateServicePayment = (params) => API.executeWithAccessToken("/generate.service.payment.link", params);

export const listPaymentsHistory = (params) => {
    return API.executeWithAccessToken(`/payments.list`, params);
}

    
